import React from 'react';
import { useField, useFormikContext } from 'formik';
import { css } from 'styled-components/macro';

import * as bs from 'bs';
import DatePicker from 'components/DatePicker';
import CheckboxComponent from 'components/Checkbox';
import { isValidPhoneNumber } from 'utils/formHelpers';


export const Checkbox = ({ validate, ...fieldProps }) => {
    const [field, meta, helpers] = useField({ validate, ...fieldProps });

    return (
        <CheckboxComponent
            {...field}
            {...fieldProps}
            checked={field.value ? field.value : false}
            onChange={checked => helpers.setValue(checked)}
            error={meta.touched && meta.error ? meta.error : null}
        />
    );
};

export const Input = ({ validate, ...fieldProps }) => {
    const [field, meta] = useField({ validate, ...fieldProps });

    return (
        <bs.Input
            {...field}
            {...fieldProps}
            errorText={meta.touched && meta.error ? meta.error : null}
        />
    );
};

export const FormikPhoneInput = fieldProps => {

    const [field, meta] = useField({
        validate: isValidPhoneNumber,
        ...fieldProps
    });

    return (
        <bs.Input
            {...field}
            {...fieldProps}
            type='text'
            placeholder='+1 441 XXX-XXXX'
            errorText={meta.touched && meta.error ? meta.error : null}
        />
    );

};

export const FormikDatePicker = ({ validate, ...fieldProps }) => {
    const [field, meta, helpers] = useField({ validate, ...fieldProps });
    const dateChange = value => helpers.setValue(value);

    return (
        <DatePicker
            {...field}
            onChange={dateChange}
            initialValue={field.value ? field.value : ''}
            {...fieldProps}
            errorText={meta.touched && meta.error ? meta.error : null}
        />
    );
};

export const FormikPhoneNumber = ({ validate, ...fieldProps }) => {
    const [field, meta, helpers] = useField({ validate, ...fieldProps });
    const onChange = e => helpers.setValue(e);
    const onBlur = () => helpers.setTouched(field.name);

    return (
        <bs.PhoneNumberInput
            {...field}
            {...fieldProps}
            validate={validate}
            onChange={onChange}
            onBlur={onBlur}
            errorText={meta.touched && meta.error ? meta.error : null}
        />
    );
};

export const FormikSelectInput = ({ validate, ...fieldProps }) => {
    const [field, meta] = useField({ validate, ...fieldProps });
    const formikProps = useFormikContext();
    const style = css`
        div[class*='is-selected'] .text-muted {
            color: ${props => props.theme.color.white} !important;
        }
    `;

    return (
        <bs.FormikSelectInput
            {...field}
            {...fieldProps}
            css={style}
            onChange={fieldProps.onChange || undefined}
            formikProps={formikProps}
            errorText={meta.touched && meta.error ? meta.error : null}
        />
    );
};

export const Select = ({ validate, ...fieldProps }) => {
    const [field, meta] = useField({ validate, ...fieldProps });

    const { onBlur, onChange, ...restField } = field;

    // call blur on change too (blur sets touched in formik, change does not
    // this leads to weird behavior when you don't explicitly defocus a select
    const selectChange = e => {
        onChange(e);
        onBlur(e);
    };

    return (
        <bs.Select
            onBlur={onBlur}
            onChange={selectChange}
            {...restField}
            {...fieldProps}
            errorText={meta.touched && meta.error ? meta.error : null}
        />
    );
};

export const SelectButton = ({ validate, ...fieldProps }) => {
    const [field, meta, helpers] = useField({ validate, ...fieldProps });
    const onChange = e => helpers.setValue(e);
    const onBlur = () => helpers.setTouched(field.name);

    return (
        <bs.SelectButton
            {...fieldProps}
            onBlur={onBlur}
            onChange={onChange}
            errorText={meta.touched && meta.error ? meta.error : null}
            value={field.value}
        />
    );
};

export const FileInput = ({ validate, ...fieldProps }) => {
    const [field, meta, helpers] = useField({ validate, ...fieldProps });
    const onChange = e => helpers.setValue(e);
    const onBlur = () => helpers.setTouched(field.name);

    return (
        <bs.FileInput
            onBlur={onBlur}
            onChange={onChange}
            errorText={meta.touched && meta.error ? meta.error : null}
            {...fieldProps}
        />
    );
};
